import { useNavigate } from 'react-router-dom';
import { ArrowRight, Download } from 'lucide-react';
import { Reveal } from './Reveal';
import { IMG } from './HeroContrast';

export const Closing = () => {
  const navigate = useNavigate();
  return (
    <section className="relative min-h-[90vh] flex items-end overflow-hidden" data-testid="closing-section">
      <img src={IMG('vie_roulotte')} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover pp-kenburns-slow" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F19] via-[#0B0F19]/70 to-[#0B0F19]/30" />
      <div className="relative z-10 max-w-6xl mx-auto px-6 sm:px-10 pb-24 md:pb-32 w-full">
        <Reveal>
          <p className="font-heading text-4xl sm:text-5xl lg:text-7xl uppercase font-bold tracking-tight text-white leading-[0.92] max-w-5xl" data-testid="closing-text">
            Vous méritez mieux que de perdre une partie de votre vie à faire circuler une information <span className="text-amber-400">qui existe déjà.</span>
          </p>
        </Reveal>
        <Reveal delay={250} className="mt-12 flex flex-col sm:flex-row gap-4">
          <button onClick={() => navigate('/admin/register')} data-testid="closing-cta-trial"
            className="inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400 text-black font-bold px-8 py-4 rounded-full transition-colors">
            Essai gratuit 30 jours <ArrowRight size={18} />
          </button>
          <button onClick={() => navigate('/register')} data-testid="closing-cta-driver"
            className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-xl border border-white/20 hover:bg-white/15 text-white font-semibold px-8 py-4 rounded-full transition-colors">
            <Download size={18} /> App chauffeur gratuite
          </button>
        </Reveal>
      </div>
    </section>
  );
};
